const AUTH_TOKEN_KEY = 'auth-token'

export default defineNuxtPlugin(() => {
  // Global interceptor for $fetch to handle 401 responses
  // Note: Authorization headers are added by composables via getAuthHeaders()
  const customFetch = $fetch.create({
    onResponseError({ response }) {
      // Handle 401 Unauthorized - clear token and redirect to login
      if (response.status === 401) {
        const token = useCookie<string | null>(AUTH_TOKEN_KEY)
        token.value = null
        navigateTo('/login')
      }
    },
  })

  // Override globalThis.$fetch
  globalThis.$fetch = customFetch

  // A reload keeps the token cookie but loses the in-memory session: without this, the auth
  // state is only ever populated right after a login.
  useAuth().initAuth()
})
